import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!localStorage.getItem('access_token')) {
      return next.handle(req);
    }

    const token = JSON.parse(localStorage.getItem('access_token'));
    if (!token) {
      return next.handle(req);
    }

    let headers = req.headers
      .set('Authorization', `Bearer ${token}`);

    const cloneReq = req.clone({ headers });
    // 'Content-Type': 'application/json',
    // 'X-Requested-With': 'XMLHttpRequest',

    return next.handle(cloneReq);
  }
}
